// Mock data for Detectivi Bacau website

export const companyInfo = {
  name: "Detectivi Bacău",
  tagline: "Agenție de Detectivi Particulari",
  phone: "+40 725 040 500",
  email: "detectiviexperti@gmail.com",
  address: "Bulevardul Unirii, Nr. 20, Bacău",
  workingHours: "Program NON-STOP 24/7",
  experience: "15+ ani experiență",
  casesResolved: "600+",
  satisfactionRate: "99%",
  discretionGuarantee: "100%",
  whatsapp: "40725040500"
};

export const mottos = [
  "Descoperim ceea ce alții încearcă să ascundă!",
  "Ochiul tău invizibil!",
  "Află tot. Acum!"
];

export const services = [
  {
    id: 1,
    title: "Verificare Fidelitate Partener",
    description: "Suspiciuni privind fidelitatea partenerului? Oferim investigații discrete și profesionale pentru a afla adevărul. Rezultate clare, dovezi concrete.",
    icon: "Heart",
    features: ["Supraveghere discretă", "Dovezi foto/video", "Raport detaliat", "Confidențialitate totală"]
  },
  {
    id: 2,
    title: "Background Check Corporate",
    description: "Verificări complete de antecedente pentru angajați, parteneri de afaceri sau investitori. Protejați-vă compania de riscuri.",
    icon: "Building",
    features: ["Verificare CV", "Antecedente penale", "Referințe profesionale", "Due diligence"]
  },
  {
    id: 3,
    title: "Detectare Camere/Microfoane",
    description: "Scanare profesională pentru detectarea dispozitivelor de supraveghere ascunse. Protejați-vă intimitatea și informațiile confidențiale.",
    icon: "Radio",
    features: ["Scanare RF completă", "Detectare GPS", "Verificare vehicule", "Raport tehnic"]
  },
  {
    id: 4,
    title: "Teste Poligraf",
    description: "Teste detector de minciuni efectuate de examinatori certificați. Rezultate precise pentru cazuri personale sau profesionale.",
    icon: "Activity",
    features: ["Examinator autorizat", "Echipament profesional", "Rezultate rapide", "Confidențial"]
  },
  {
    id: 5,
    title: "Fraude Asigurări",
    description: "Investigații specializate pentru detectarea fraudelor în domeniul asigurărilor. Colaborăm cu companii și persoane fizice.",
    icon: "FileWarning",
    features: ["Investigații accidente", "Verificare daune", "Dovezi legale", "Expertize"]
  }
];

export const trustElements = [
  {
    id: 1,
    value: "600+",
    label: "Cazuri Rezolvate",
    description: "De-a lungul anilor"
  },
  {
    id: 2,
    value: "99%",
    label: "Rată de Succes",
    description: "Clienți mulțumiți"
  },
  {
    id: 3,
    value: "15+",
    label: "Ani Experiență",
    description: "În investigații"
  },
  {
    id: 4,
    value: "100%",
    label: "Discreție",
    description: "Garantată"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Alexandru M.",
    location: "Bacău",
    text: "Profesionalism desăvârșit. Au rezolvat cazul meu în timp record și cu discreție totală. Recomand cu încredere!",
    rating: 5
  },
  {
    id: 2,
    name: "Maria D.",
    location: "Onești",
    text: "Am apelat la ei pentru o investigație delicată. Rezultatele au fost clare și au depășit așteptările mele.",
    rating: 5
  },
  {
    id: 3,
    name: "Compania XYZ SRL",
    location: "Bacău",
    text: "Colaborăm de ani de zile pentru verificări de personal. Servicii impecabile și rapoarte detaliate.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "Cât costă serviciile de investigație?",
    answer: "Costurile variază în funcție de complexitatea cazului, durata investigației și resursele necesare. Oferim o consultație gratuită inițială pentru evaluarea cazului."
  },
  {
    question: "Cât durează o investigație?",
    answer: "Durata depinde de tipul cazului. Unele investigații se pot finaliza în câteva zile, altele pot dura săptămâni. Vă vom oferi o estimare după evaluarea inițială."
  },
  {
    question: "Sunt informațiile confidențiale?",
    answer: "Absolut. Confidențialitatea este garantată prin contract. Toate informațiile și dovezile sunt tratate cu maximă discreție și securitate."
  },
  {
    question: "Dovezile obținute sunt valabile în instanță?",
    answer: "Da, dovezile pe care le furnizăm sunt obținute legal și pot fi utilizate în proceduri judiciare, cu respectarea legislației în vigoare."
  }
];

export const licenseImage = "https://customer-assets.emergentagent.com/job_sleuth-focsani-clone/artifacts/8jymo26r_Detectiv%20Bacau%20Licenta.jpg";
